import type { ActivityEntry } from '../ActivityChapter.interface';
import Activity from './Activity';
import Intro from './Intro';

interface EntryLayoutProps {
    entry: ActivityEntry;
    allEntries: Array<ActivityEntry>;
}

function EntryLayout({ entry, allEntries }: EntryLayoutProps) {
    return entry.event_type === 'intro' ? (
        <Intro
            entry={entry}
            allEntries={allEntries}
        />
    ) : (
        <Activity
            entry={entry}
        />
    );
}

export default EntryLayout;
